import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { FilterFormTypes } from "models/formTypes";
import { FilterSaveFormContainerProps } from "models/propTypes/filterPropTypes";
//#endregion
//#region components
import FilterSaveForm from "./saveForm";
//#endregion
import * as Yup from "yup";

const FilterSaveFormContainer: ForwardRefRenderFunction<FormHandles, FilterSaveFormContainerProps> = (props, ref) => {
  const { filter } = props;

  const validationSchema = Yup.object<FilterFormTypes.Save>({
    id: Yup.number(),
    name: Yup.string().required(TranslationKeys.Validations.Required),
    returnRelativeDates: Yup.bool(),
    isDefault: Yup.bool(),
  });

  const defaultValues: FilterFormTypes.Save = {
    id: filter?.id,
    name: filter?.name ?? "",
    returnRelativeDates: filter?.returnRelativeDates ?? false,
    isDefault: filter?.isDefault ?? false,
  };

  return <FilterSaveForm ref={ref} {...props} validationSchema={validationSchema} defaultValues={defaultValues} />;
};

export default forwardRef(FilterSaveFormContainer);
